import React from 'react';
import { track } from '@amplitude/analytics-browser';
import { Accordion, Box, Text, Title } from '@nimbus-ds/components';
import { useIsMobile } from 'commons/hooks';
import { useTranslationWithPrefix } from 'commons/utils';

const FaqAccordionSection = () => {
  const { t } = useTranslationWithPrefix('landing.faqAccordionSection');

  const isMobile = useIsMobile();

  const faqs = [
    {
      id: 'payment-methods',
      question: t('items.paymentMethods.question'),
      answer: t('items.paymentMethods.answer'),
    },
    {
      id: 'security',
      question: t('items.security.question'),
      answer: t('items.security.answer'),
    },
    {
      id: 'when-i-see-money',
      question: t('items.whenISeeMoney.question'),
      answer: t('items.whenISeeMoney.answer'),
    },
    {
      id: 'redirect',
      question: t('items.redirect.question'),
      answer: t('items.redirect.answer'),
    },
    {
      id: 'withdraw-money',
      question: t('items.withdrawMoney.question'),
      answer: t('items.withdrawMoney.answer'),
    },
    {
      id: 'rejected-payment',
      question: t('items.rejectedPayment.question'),
      answer: t('items.rejectedPayment.answer'),
    },
  ] as const;

  const handleFaqClick = (questionTitle: string) => {
    track('tiendanube_mx_pagonube_landing_faq_click', {
      question_title: questionTitle,
    });
  };

  return (
    <Box marginY="8">
      <Box marginBottom="6">
        <Title as={isMobile ? 'h3' : 'h2'}>{t('title')}</Title>
      </Box>

      <Accordion>
        {faqs.map((faq) => (
          <Accordion.Item key={faq.id} index={faq.id}>
            <Accordion.Header
              title={faq.question}
              onClick={() => handleFaqClick(faq.question)}
            />
            <Accordion.Body>
              <Text color="neutral-textLow">{faq.answer}</Text>
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </Box>
  );
};

export default FaqAccordionSection;
